import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from "./app.component";
import { RouterModule, Routes, ActivatedRoute } from "@angular/router";
import {
  BsDropdownModule,
  AccordionModule,
  CollapseModule,
  ModalModule,
  AlertModule
} from "ngx-bootstrap";

import { NgxGalleryModule } from "ngx-gallery";
import { DragulaModule } from "ng2-dragula/ng2-dragula";
import { TabsModule } from "ngx-bootstrap";

//import { LoadingModule } from 'ngx-loading';
// Primeng Plugin
import {
  FileUploadModule,
  ProgressBarModule,
  CalendarModule,
  MenuModule,
  MenuItem,
  DropdownModule,
  GalleriaModule
} from "primeng/primeng";
import { ColorPickerModule } from "ngx-color-picker";

import { HeaderComponent } from "./layout/header/header.component";
import { LeftMenuComponent } from "./layout/left-menu/left-menu.component";
import { InfoComponent } from "./event/info/info";
import { MenuTypeComponent } from "./event/menu-type/menu-type";
import { AboutUsComponent } from "./event/about-us/about-us.component";
import { AboutCityComponent } from "./event/about-city/about-city.component";
import { LiveStreamingComponent } from "./event/live-streaming/live-streaming.component";
import { Registration2Component } from "./event/registration2/registration2.component";

import { LoginComponent } from "./user/login/login.component";
import { ForgotPasswordComponent } from "./user/forgot-password/forgot-password.component";
import { WelcomeComponent } from "./event/welcome/welcome.component";
import { AngularFireModule } from "angularfire2";
import { AngularFireDatabaseModule } from "angularfire2/database";
import * as firebase from "firebase";
import { environment } from "../environments/environment";
import { AuthService } from "./core/services/auth.service";
import { AngularFireAuth } from "angularfire2/auth";
import { ExtraService } from "./core/services/extra.service";
import { AuthguardGuard } from "./core/guards/authguard.guard";
import { UtilityService } from "./core/services/utility.service";
import { appRoutes } from "./app.routes";
import { AgmCoreModule } from "@agm/core";
import { MenuItemsComponent } from "./event/menu-items/menu-items";
import { ThemeComponent } from "./event/theme/theme.component";

import { ThemeService } from "./core/services/theme.service";

import {
  BrowserAnimationsModule,
  NoopAnimationsModule
} from "@angular/platform-browser/animations";
import { SpeakersFormComponent } from "./event/speakers-form/speakers-form.component";
import { SpeakerProfileComponent } from "./event/speaker-profile/speaker-profile.component";
import { SpeakerService } from "./core/services/speaker.service";

import { SessionsFormComponent } from "./event/sessions-form/sessions-form.component";
import { SessionsAddComponent } from "./event/sessions-add/sessions-add.component";
import { SessionService } from "./core/services/session.service";
import { SessionTopicService } from "./core/services/session-topic.service";

import { RegistrationComponent } from "./user/registration/registration.component";
import { ProfileComponent } from "./user/profile/profile.component";
import { ContentFormComponent } from "./event/content-form/content-form.component";
import { SliderComponent } from "./layout/slider/slider.component";
import { InputSwitchModule } from "primeng/primeng";
import { MenuTypeService } from "./core/services/menu-type.service";

import { ConfirmDialogModule, ConfirmationService } from "primeng/primeng";

import { ImageSliderComponent } from "./event/image-slider/image-slider.component";
import { ContentAddComponent } from "./event/content-add/content-add.component";
import { ContentService } from "./core/services/content.service";

import { PollFormComponent } from "./event/poll-form/poll-form.component";
import { PollAddComponent } from "./event/poll-add/poll-add.component";
import { PollService } from "./core/services/poll.service";

import { SponsorsFormComponent } from "./event/sponsors-form/sponsors-form.component";
import { SponsorsService } from "./core/services/sponsors.service";
import { ExhibitorsService } from "./core/services/exhibitors.service";
import { OrganizersService } from "./core/services/organizers.service";

import { QuestionAnswerService } from "./core/services/question-answer.service";
import { FeedbackService } from "./core/services/feedback.service";
import { PollListService } from "./core/services/poll-list.service";

import { ContactUsFormComponent } from "./event/contact-us-form/contact-us-form.component";
import { ContactUsAddComponent } from "./event/contact-us-add/contact-us-add.component";
import { ContactUsService } from "./core/services/contact-us.service";

import { YoutubeVideoComponent } from "./layout/youtube-video/youtube-video.component";
import { DropDownComponent } from "./layout/drop-down/drop-down.component";
import { TextBoxComponent } from "./layout/text-box/text-box.component";
import { SpeakerSelectComponent } from './layout/speaker-select/speaker-select.component'
import { UrlBoxComponent } from "./layout/url-box/url-box.component";
import { ImageComponent } from "./layout/image/image.component";
import { VideoComponent } from "./layout/video/video.component";
import { CardsComponent } from "./layout/cards/cards.component";
import { ListComponent } from "./layout/list/list.component";
import { SubListComponent } from "./layout/sub-list/sub-list.component";

import { StaticCompComponent } from "./layout/static-comp/static-comp.component";
import { ChatroomComponent } from "./event/chatroom/chatroom.component";
import { FeedbackComponent } from "./event/feedback/feedback.component";
import { QuestionAndAnswerComponent } from "./event/question-and-answer/question-and-answer.component";

import { EventSessionComponent } from "./layout/event-session/event-session.component";
import { SubmitButtonComponent } from "./layout/submit-button/submit-button.component";
import { PublishComponent } from "./event/publish/publish.component";
import { PublishResetService } from "./core/services/publish-reset.service";
import { PopupScreenComponent } from "./event/popup-screen/popup-screen.component";
import { QuestionAnswerComponent } from "./layout/question-answer/question-answer.component";
import { PollListComponent } from "./event/poll-list/poll-list.component";
import { AttendeesComponent } from "./event/attendees/attendees.component";

import { SplashScreenComponent } from "./event/splash-screen/splash-screen.component";
import { SplashMapService } from "./core/services/splash-map.service";
import { AttendeesService } from "./core/services/attendees.service";
import { SplashHeaderComponent } from "./layout/splash-header/splash-header.component";
import { SplashFooterComponent } from "./layout/splash-footer/splash-footer.component";
import { TimeDropdownComponent } from "./layout/time-dropdown/time-dropdown.component";
import { ResetComponent } from "./event/reset/reset.component";
import { VenueDetailComponent } from "./event/venue-detail/venue-detail.component";
import { ColorPickerComponent } from "./layout/color-picker/color-picker.component";
import { HeaderImageSliderComponent } from "./layout/header-image-slider/header-image-slider.component";

import { ExhibitorListComponent } from "./event/exhibitor-list/exhibitor-list.component";
import { OrganizerListComponent } from "./event/organizer-list/organizer-list.component";
import { OrganizerAddComponent } from "./event/organizer-add/organizer-add.component";
import { NotificationComponent } from "./event/notification/notification.component";
import { Theme2Component } from "./event/theme2/theme2.component";
import { TestComponent } from "./event/test/test.component";
import { SponsorsAddNewComponent } from "./event/sponsors-add-new/sponsors-add-new.component";
import { ExhibitorAddNewComponent } from "./event/exhibitor-add-new/exhibitor-add-new.component";

import { MultiUtilityService } from "./core/services/multi-utility.service";
import { SpeakerListComponent } from "./event/speaker-list/speaker-list.component";
import { SpeakerAddComponent } from "./event/speaker-add/speaker-add.component";

import { NewPageComponent } from "./templates/new-page/new-page.component";
import { NewPageService } from "./templates/new-page/service/new-page.service";

import { ExportCsvComponent } from "./extras/export-csv/export-csv.component";
import { PollQuestionComponent } from "./event/poll-question/poll-question.component";

import { FileDropDirective } from "./core/directives/drag-drop";
import { DisclaimerComponent } from "./event/disclaimer/disclaimer.component";
import { SessionsTopicComponent } from "./event/session-topic/sessions-topic.component";
import { DisclaimerService } from "./core/services/disclaimer.service";
import { DisableFeatureService } from "./core/services/disable-feature.service";
import { Attendees2Component } from './event/attendees2/attendees2.component';
import { ActivitiesComponent } from './event/activities/activities.component';
import { ContactUsComponent } from "./user/contact-us/contact-us.component";

// Custom Transformers
import { CustomPlaceholderPipe } from "./core/pipes/custom-placeholder.pipe";
import { CustomTitlePipe } from "./core/pipes/custom-title.pipe";
import { SafeHtmlPipe } from "./core/pipes/safe-html.pipe";
import { ChairpersonSelectComponent } from './layout/chairperson-select/chairperson-select.component';
import { CoordinatorSelectComponent } from './layout/coordinator-select/coordinator-select.component';
import { PanelistSelectComponent } from './layout/panelist-select/panelist-select.component';
import { ModeratorSelectComponent } from './layout/moderator-select/moderator-select.component';
import { AlternateSpeaker1SelectComponent } from './layout/alternate-speaker1-select/alternate-speaker1-select.component';
import { AlternateSpeaker2SelectComponent } from './layout/alternate-speaker2-select/alternate-speaker2-select.component';
import { AlternateSpeaker3SelectComponent } from './layout/alternate-speaker3-select/alternate-speaker3-select.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LeftMenuComponent,
    InfoComponent,
    MenuTypeComponent,
    AboutUsComponent,
    DisclaimerComponent,
    AboutCityComponent,
    LiveStreamingComponent,
    LoginComponent,
    ForgotPasswordComponent,
    WelcomeComponent,
    MenuItemsComponent,
    ThemeComponent,
    SpeakersFormComponent,
    SpeakerProfileComponent,
    RegistrationComponent,
    Registration2Component,
    ProfileComponent,
    SessionsFormComponent,
    SessionsAddComponent,
    SessionsTopicComponent,
    ContentFormComponent,
    SliderComponent,
    ImageSliderComponent,
    ContentAddComponent,
    PollFormComponent,
    PollAddComponent,
    SponsorsFormComponent,
    ContactUsFormComponent,
    ContactUsAddComponent,
    YoutubeVideoComponent,
    SliderComponent,
    DropDownComponent,
    TextBoxComponent,
    SpeakerSelectComponent,
    UrlBoxComponent,
    ImageComponent,
    VideoComponent,
    CardsComponent,
    ListComponent,
    SubListComponent,
    CustomPlaceholderPipe,
    StaticCompComponent,
    ChatroomComponent,
    FeedbackComponent,
    QuestionAndAnswerComponent,
    EventSessionComponent,
    SubmitButtonComponent,
    PublishComponent,
    PopupScreenComponent,
    QuestionAnswerComponent,
    PollListComponent,
    AttendeesComponent,
    SplashScreenComponent,
    SplashHeaderComponent,
    SplashFooterComponent,
    TimeDropdownComponent,
    ResetComponent,
    VenueDetailComponent,
    ColorPickerComponent,
    HeaderImageSliderComponent,
    CustomTitlePipe,
    SafeHtmlPipe,
    ExhibitorListComponent,
    OrganizerListComponent,
    OrganizerAddComponent,
    NotificationComponent,
    Theme2Component,
    TestComponent,
    SponsorsAddNewComponent,
    ExhibitorAddNewComponent,
    SpeakerListComponent,
    SpeakerAddComponent,
    NewPageComponent,
    ExportCsvComponent,
    PollQuestionComponent,
    FileDropDirective,
    Attendees2Component,
    ActivitiesComponent,
    ContactUsComponent,
    ChairpersonSelectComponent,
    CoordinatorSelectComponent,
    PanelistSelectComponent,
    ModeratorSelectComponent,
    AlternateSpeaker1SelectComponent,
    AlternateSpeaker2SelectComponent,
    AlternateSpeaker3SelectComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    CollapseModule.forRoot(),
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    CommonModule,
    DragulaModule,
    // Primeng Plugin
    FileUploadModule,
    ProgressBarModule,
    CalendarModule,
    MenuModule,
    DropdownModule,
    GalleriaModule,
    NgxGalleryModule,
    ColorPickerModule,
    //LoadingModule,
    BrowserModule,
    TabsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule, // for database
    AgmCoreModule.forRoot({
      apiKey: environment.maps.apiKey,
      libraries: ["places"]
    }),
    BrowserAnimationsModule,
    NoopAnimationsModule,
    InputSwitchModule,
    ConfirmDialogModule
  ],
  entryComponents: [
    DropDownComponent,
    SliderComponent,
    YoutubeVideoComponent,
    TextBoxComponent,
    SpeakerSelectComponent,
    ChairpersonSelectComponent,
    CoordinatorSelectComponent,
    PanelistSelectComponent,
    ModeratorSelectComponent,
    AlternateSpeaker1SelectComponent,
    AlternateSpeaker2SelectComponent,
    AlternateSpeaker3SelectComponent,
    UrlBoxComponent,
    ImageComponent,
    VideoComponent,
    CardsComponent,
    ListComponent,
    SubListComponent,
    StaticCompComponent,
    HeaderImageSliderComponent
  ],
  providers: [
    ExtraService,
    AuthguardGuard,
    UtilityService,
    ConfirmationService,
    AngularFireAuth,
    DisclaimerService,
    DisableFeatureService,
    MenuTypeService,
    SpeakerService,
    SessionService,
    SessionTopicService,
    ContentService,
    PollService,
    ContactUsService,
    ExhibitorsService,
    OrganizersService,
    SponsorsService,
    NewPageService,
    MultiUtilityService,
    ThemeService
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /app/src/app/app.module.ts